import type { ButtonProps } from '@mui/material';
import { Button } from '@mui/material';
import { themeConfig } from 'src/theme';

interface ButtonJumboProps extends ButtonProps {
  // Tambahkan props khusus untuk ButtonJumbo jika diperlukan
}

export const ButtonJumbo: React.FC<ButtonJumboProps> = (props) => (
  <Button
    {...props}
    fullWidth
    variant="contained"
    sx={{
      background: themeConfig.gradient.primary.bold,
      height: {
        xs: '62px',
        md: '70px',
      },
      borderRadius: '50px',
      ...props.sx,
    }}
    size="large"
  >
    {props.children}
  </Button>
);
